import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Bilgi from "./pages/Bilgi";
import Hizmetler from "./pages/Hizmetler";
import ForgotPassword from "./Login/ForgotPassword";
import ResetPassword from "./Login/ResetPassword";
import Danismanlik from "./pages/Danismanlik";
import İletisim from "./pages/İletisim";
import Acasa from "./pages/Acasa";
import Home from "./pages/Home";
import Login from "./Login/Login";
import Blog from "./pages/Blog";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ErrorPage from "./pages/ErrorPage";
import AppointmentForm from './pages/AppointmentForm';
import CalendarView from './pages/CalendarView';
import Signup from "./Signup/Signup";
import BlogDetay from './pages/BlogDetay';
import AdminDashboard from "./pages/admin/AdminDashboard";

const isAdmin = localStorage.getItem("email") === "av.aliardagul@gmail.com";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Helmet>
  <title>Ali Arda Gül Hukuk Bürosu | Ankara Avukatlık ve Hukuki Danışmanlık</title>

  {/* SEO Açıklaması */}
  <meta
    name="description"
    content="Ali Arda Gül, Ankara'da hukuki danışmanlık ve avukatlık hizmetleri sunmaktadır. Aile, ticaret, ceza hukuku ve daha fazlasında güvenilir bir çözüm ortağı."
  />

  {/* Anahtar Kelimeler */}
  <meta
    name="keywords"
    content="avukat, Ankara, hukuki hizmetler, aile hukuku, ticaret hukuku, ceza hukuku, Ali Arda Gül"
  />

  {/* Yazar Adı */}
  <meta name="author" content="Ali Arda Gül" />
</Helmet>


        <Routes>
          <Route path="/" element={<><Home /><Footer /></>} />
          <Route path="/Home" element={<><Navbar /><Acasa /><Footer /></>} />
          <Route path="/Bilgi" element={<><Navbar /><Bilgi /><Footer /></>} />
          <Route path="/Hizmetler" element={<><Navbar /><Hizmetler /><Footer /></>} />
          <Route path="/Danismanlik" element={<><Navbar /><Danismanlik /><Footer /></>} />
          <Route path="/iletisim" element={<><Navbar /><İletisim /><Footer /></>} />
          <Route path="/blog" element={<><Navbar /><Blog /><Footer /></>} />
          <Route path="/blog/:id" element={<><Navbar /><BlogDetay /><Footer /></>} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Randevu sayfaları */}
         
          <Route path="/appointment-form" element={<><Navbar /><AppointmentForm /><Footer /></>} />
          <Route path="/calendar" element={<><Navbar /><CalendarView /><Footer /></>} />

          {/* Admin Panel */}
          <Route path="/admin/*" element={isAdmin ? <AdminDashboard /> : <Navigate to="/login" />} />

          {/* Hata Sayfası */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
